// TODO: 联调时替换为接口数据

// 可选产品（当前企业拥有的产品）
export const mockProducts = [
  { id: 'P5xJS90pll', name: '普通单目云台摄像机', model: 'IPC-001', deviceCount: 156 },
  { id: 'PfmULRthXq', name: 'N2普通云台摄像机', model: 'IPC-N2', deviceCount: 89 },
  { id: 'PRD_GW001', name: '工业网关 G100', model: 'GW-100', deviceCount: 42 },
  { id: 'PRD_THS002', name: '温湿度传感器', model: 'THS-V2', deviceCount: 230 },
];

// 合作企业（可作为接收方）
export const mockEnterprises = [
  { id: 'ENT_8801', name: '极客智控科技有限公司' },
  { id: 'ENT_8802', name: '蓝海工业自动化' },
  { id: 'ENT_8803', name: '森态环境监测中心' },
  { id: 'A619355x', name: '捷顺科技股份有限公司' },
  { id: 'HM_8827_X', name: '深圳汇云科技' },
];

// 生产工单
// 可选条件：状态=已完成/已终止 且 License数量>0
export const mockOrders = [
  { id: 'PO20260501001', orderName: '2026年5月第一批摄像头生产', productId: 'P5xJS90pll', productName: '普通单目云台摄像机', licenseCount: 50, status: '已完成' },
  { id: 'PO20260420003', orderName: 'N2摄像机4月补产', productId: 'PfmULRthXq', productName: 'N2普通云台摄像机', licenseCount: 30, status: '已完成' },
  { id: 'PO20260415007', orderName: '工业网关正式投产', productId: 'PRD_GW001', productName: '工业网关 G100', licenseCount: 20, status: '已终止' },
  { id: 'PO20260515002', orderName: '温湿度传感器试产', productId: 'PRD_THS002', productName: '温湿度传感器', licenseCount: 100, status: '生产中' },
  { id: 'PO20260301009', orderName: '4G摄像头测试批次', productId: 'PRD_4G001', productName: '4G摄像机', licenseCount: 0, status: '已完成' },
  { id: 'PO20260520005', orderName: 'IPC-001追加生产', productId: 'P5xJS90pll', productName: '普通单目云台摄像机', licenseCount: 80, status: '已完成' },
];

// 模拟 License 列表（用于明细抽屉）
export const generateMockLicenses = (count, prefix = '010HMP') => {
  const list = [];
  for (let i = 1; i <= count; i++) {
    list.push({
      key: `${i}`,
      license: `${prefix}${String(2511130000 + i).slice(0, 4)}${String.fromCharCode(65 + (i % 26))}${String.fromCharCode(97 + (i % 26))}${String.fromCharCode(84 + (i % 10))}`,
      status: i % 7 === 0 ? 'transferring' : 'active',
      bindStatus: i % 3 === 0 ? '已绑定' : '未绑定',
    });
  }
  return list;
};

// 模拟冲突设备（已被其他转移锁定）
export const mockConflictLicenses = [
  '010HMP251113cUbT',
  '010HMT251111Y8Ld',
];

// ══════════════════════════════════════════════
//  转移任务列表（发起方视角 - out）
// ══════════════════════════════════════════════
export const mockOutTasks = [
  {
    id: 'TRF202605080001',
    type: 'out',
    targetEnterprise: '极客智控科技有限公司',
    targetEnterpriseId: 'ENT_8801',
    productName: '普通单目云台摄像机',
    productId: 'P5xJS90pll',
    deviceCount: 50,
    status: 'pending',       // 待对方确认
    creator: 'Admin',
    createTime: '2026-05-08 10:00:00',
    remark: '第一批试用调拨',
    licenses: generateMockLicenses(50, '010HMP'),
  },
  {
    id: 'TRF202605060003',
    type: 'out',
    targetEnterprise: '森态环境监测中心',
    targetEnterpriseId: 'ENT_8803',
    productName: '温湿度传感器',
    productId: 'PRD_THS002',
    deviceCount: 100,
    status: 'rejected',      // 对方已拒绝
    creator: 'Admin',
    createTime: '2026-05-06 09:15:00',
    remark: '北区项目配套',
    rejectReason: '暂时无库容接收，下月再议',
    licenses: generateMockLicenses(100, '010THS'),
  },
  {
    id: 'TRF202605010002',
    type: 'out',
    targetEnterprise: '蓝海工业自动化',
    targetEnterpriseId: 'ENT_8802',
    productName: '工业网关 G100',
    productId: 'PRD_GW001',
    deviceCount: 20,
    status: 'completed',     // 对方已接收
    creator: 'Admin',
    createTime: '2026-05-01 11:20:00',
    remark: '正式交付，网关设备移交',
    licenses: generateMockLicenses(20, '010GW'),
  },
  {
    id: 'TRF202604280002',
    type: 'out',
    targetEnterprise: '极客智控科技有限公司',
    targetEnterpriseId: 'ENT_8801',
    productName: 'N2普通云台摄像机',
    productId: 'PfmULRthXq',
    deviceCount: 15,
    status: 'revoked',       // 我已撤销
    creator: 'Admin',
    createTime: '2026-04-28 14:00:00',
    remark: '发错企业了，已撤销',
    licenses: generateMockLicenses(15, '010N2'),
  },
];

// ══════════════════════════════════════════════
//  转移任务列表（接收方视角 - in）
// ══════════════════════════════════════════════
export const mockInTasks = [
  {
    id: 'TRF202605090001',
    type: 'in',
    sourceEnterprise: '捷顺科技股份有限公司',
    sourceEnterpriseId: 'A619355x',
    productName: '智能门锁 S1',
    productId: 'PRD_SL001',
    deviceCount: 30,
    status: 'pending_receive',  // 待我接收
    creator: 'Partner_D',
    createTime: '2026-05-09 09:00:00',
    remark: '测试设备发放，请尽快确认',
    licenses: generateMockLicenses(30, '010SL'),
  },
  {
    id: 'TRF202605070002',
    type: 'in',
    sourceEnterprise: '深圳汇云科技',
    sourceEnterpriseId: 'HM_8827_X',
    productName: '4G摄像机',
    productId: 'PRD_4G001',
    deviceCount: 12,
    status: 'pending_receive',  // 待我接收
    creator: 'Partner_E',
    createTime: '2026-05-07 16:30:00',
    remark: '紧急项目需求，请今天内确认',
    licenses: generateMockLicenses(12, '0104G'),
  },
  {
    id: 'TRF202605050003',
    type: 'in',
    sourceEnterprise: '蓝海工业自动化',
    sourceEnterpriseId: 'ENT_8802',
    productName: '工业网关 G100',
    productId: 'PRD_GW001',
    deviceCount: 10,
    status: 'received',      // 我已接收
    creator: 'Partner_A',
    createTime: '2026-05-05 14:30:00',
    remark: '样机转移，已确认',
    licenses: generateMockLicenses(10, '010GW'),
  },
  {
    id: 'TRF202605030004',
    type: 'in',
    sourceEnterprise: '森态环境监测中心',
    sourceEnterpriseId: 'ENT_8803',
    productName: '温湿度传感器',
    productId: 'PRD_THS002',
    deviceCount: 5,
    status: 'rejected',      // 我已拒绝
    creator: 'Partner_C',
    createTime: '2026-05-03 16:10:00',
    remark: '数量与约定不符',
    rejectReason: '约定20台，实际收到申请5台，数量不符，请重新发起',
    licenses: generateMockLicenses(5, '010THS'),
  },
  {
    id: 'TRF202604290005',
    type: 'in',
    sourceEnterprise: '蓝海工业自动化',
    sourceEnterpriseId: 'ENT_8802',
    productName: '工业网关 G100',
    productId: 'PRD_GW001',
    deviceCount: 25,
    status: 'revoked_by_other',  // 对方已撤销
    creator: 'Partner_A',
    createTime: '2026-04-29 10:00:00',
    remark: '对方发现发错货，已撤回',
    licenses: generateMockLicenses(25, '010GW'),
  },
];
